import React from 'react';
import Navigation from './components/Navigation';
import { BrowserRouter as Router } from 'react-router-dom';
import { Flex, Footer, PageWrapper } from './styles/components';
import Layout from './styles/components/Layout';
import { auth } from './firebase';
import withAuthentication from './hoc/withAuthentication';
import Pages from './pages';
import { connect } from 'react-redux';
import Adsense from 'react-adsense';
import fire from './firebase';
import { compose } from 'recompose';
class App extends React.Component {
  componentWillMount() {
    const snippetsRef = fire
      .database()
      .ref('snippets/public')
      .orderByKey()
      .limitToLast(60);
    snippetsRef.on('child_added', snapshot => {
      this.props.onGetSnippet({ key: snapshot.key, ...snapshot.val() });
    });
    const categoryRef = fire
      .database()
      .ref('categories')
      .orderByKey()
      .limitToLast(60);
    categoryRef.on('child_added', snapshot => {
      this.props.onGetCategory({ key: snapshot.key, ...snapshot.val() });
    });
  }
  render() {
    return (
      <Router>
        <Flex
          direction="column"
          justify="space-between"
          height="100vh"
          style={{ overflow: 'hidden' }}
        >
          <Navigation />
          <PageWrapper
            style={{ display: 'flex', height: '100%', overflow: 'auto' }}
          >
            <Pages />
          </PageWrapper>
          <Footer>
            <div>
              <h5>Codespurts</h5>
            </div>
          </Footer>
        </Flex>
      </Router>
    );
  }
}
const mapDispatchToProps = dispatch => ({
  onGetSnippet: snippet => dispatch({ type: 'PUBLIC_SNIPPET_ADD', snippet }),
  onGetCategory: category => dispatch({ type: 'CATEGORY_ADD', category })
});
export default compose(
  withAuthentication,
  connect(
    null,
    mapDispatchToProps
  )
)(App);
